<template>
  <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3" id="tokensCard">
    <div v-if="!bought" class="tokens-card">
      <div v-if="isBest" class="best-choice">
        <i class="fa fa-star"></i>
      </div>
      <div class="tokens--count">
        <h4>{{ tokensCount }} Tokens</h4>
      </div>
      <div class="divider"></div>
      <div class="tokens--price">
        <span>{{ price }}</span>
      </div>
      <div class="description">
        <span>All features included</span>
        <span>No extra costs</span>
      </div>
      <div class="text-center">
        <mdb-btn @click="buy" class="text-white mt-5" outline="primary">BUY NOW</mdb-btn>
      </div>
    </div>

    <div v-if="bought" class="tokens-card d-flex justify-content-center align-items-center bought">
      <p class="text-center">Successfully bought {{ tokensCount }} tokens! {{ bought }}</p>
      <i class="fas fa-check"></i>
    </div>
  </div>
</template>

<script>
import { mdbBtn } from "mdbvue";
export default {
  name: "TokensCard",
  components: { mdbBtn },
  props: ["productId", "tokensCount", "price", "isBest"],
  data: function() {
    return {
      bought: false
    };
  },
  methods: {
    buy: function() {
      const userId = this.user.id;
      const userMail = this.user.email;
      const that = this;
      window.Paddle.Checkout.open({
        product: this.productId,
        passthrough: userId,
        email: userMail,
        successCallback: function() {
          let tries = 5;
          that.$store.commit("ui/is_loading", true);
          const tokens = that.$store.getters["user/user"].tokens;

          for (let index = 1; index < tries; index++) {
            setTimeout(() => {
              that.$store
                .dispatch("user/updateUser")
                .then(() => {
                  const tokensNow = that.$store.getters["user/user"].tokens;
                  if (tokensNow > tokens) {
                    that.$store.commit("ui/is_loading", false);
                    this.$toasted.show(
                      "Successfully bought " + that.tokensCount + " tokens.",
                      {
                        theme: "bubble",
                        position: "top-center",
                        duration: 2000
                      }
                    );
                    return;
                  }
                })
                .catch(err => console.log(err));
            }, 2000);
          }
        },
        closeCallback: function() {}
      });
    }
  },
  computed: {
    user: function() {
      return this.$store.getters["user/user"];
    }
  }
};
</script>
